import { render, staticRenderFns } from "./ProductUnitList.vue?vue&type=template&id=7895171f&scoped=true&"
import script from "./ProductUnitList.vue?vue&type=script&lang=js&"
export * from "./ProductUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895171f",
  null
  
)

export default component.exports